import React from 'react'

const CheckboxBlackChecked = ({}) => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 2C0 0.89543 0.895431 0 2 0H16C17.1046 0 18 0.895431 18 2V16C18 17.1046 17.1046 18 16 18H2C0.89543 18 0 17.1046 0 16V2Z"
      fill="#3E3E47"
    />
    <path
      d="M1 2C1 1.44772 1.44772 1 2 1H16C16.5523 1 17 1.44772 17 2V16C17 16.5523 16.5523 17 16 17H2C1.44771 17 1 16.5523 1 16V2Z"
      stroke="#282832"
      strokeWidth="2"
    />
    <path
      d="M6.87396 11.5967L4.07396 8.7967L3.14062 9.73003L6.87396 13.4634L14.874 5.46336L13.9406 4.53003L6.87396 11.5967Z"
      fill="white"
    />
  </svg>
)

export default CheckboxBlackChecked
